module.exports = __webpack_public_path__ + "img/business-history.svg";